<template>
  <div
    v-on-click-outside="closeMenu"
    class="w-[200px] text-black md:text-corepla-text -mt-5 md:-mt-0 shadow hidden left-0 md:block absolute md:static z-10 md:w-1/5 md:uppercase text-sm md:text-xs md:border-r bg-white"
    :class="{ '!block': uiStore.menu }"
  >
    <div
      class="md:border-b"
      :class="{ 'md:border-b bg-gray-200': (name === 'auctions' || name.startsWith('auction')) && name !== 'auction_calendars' }"
    >
      <RouterLink
        to="/aste"
        class="block hover:bg-corepla-bg-light p-2"
        @click="closeMenu"
      >
        <ChatBubbleBottomCenterIcon class="h-4 w-4 inline-block mr-2" />
        {{ $t("menu.auctions") }}
      </RouterLink>
    </div>
    <div
      class="md:border-b"
      :class="{ 'md:border-b bg-gray-200': name === 'auction_calendars' }"
    >
      <RouterLink
        to="/calendario-aste"
        class="block hover:bg-corepla-bg-light p-2"
        @click="closeMenu"
      >
        <CalendarIcon class="h-4 w-4 inline-block mr-2" />
        {{ $t("menu.auction_calendars") }}
      </RouterLink>
    </div>
    <div
      class="md:border-b"
      :class="{ 'md:border-b bg-gray-200': name === 'subscribers' }"
    >
      <RouterLink
        to="/iscritti"
        class="block hover:bg-corepla-bg-light p-2"
        @click="closeMenu"
      >
        <UserGroupIcon class="h-4 w-4 inline-block mr-2" />
        {{ $t("menu.subscribers") }}
      </RouterLink>
    </div>
    <div
      class="md:border-b"
      :class="{ 'md:border-b bg-gray-200': name === 'selection_sites' }"
    >
      <RouterLink
        to="/centri-selezione"
        class="block hover:bg-corepla-bg-light p-2"
        @click="closeMenu"
      >
        <WalletIcon class="h-4 w-4 inline-block mr-2" />
        {{ $t("menu.selection_sites") }}
      </RouterLink>
    </div>
  </div>
</template>
  
<script setup>
import { CalendarIcon, ChatBubbleBottomCenterIcon, UserGroupIcon,  WalletIcon } from '@heroicons/vue/24/outline'
import { vOnClickOutside } from '@vueuse/components'
import { useRoute } from 'vue-router';

import { useUiStore } from '../stores/ui';

const { name } = useRoute()

const uiStore = useUiStore()

const closeMenu = function () {
  uiStore.menu = false;
}
</script>